<ui-title [title]="'Live SOD Clashes'">
	<div class="col-lg-6 float-right">
		<ui-loading [loading]="clashes.loading"></ui-loading>
	</div>
</ui-title>

<ui-alert
	*ngIf="modalAlert.display"
	[title]="modalAlert.title"
	[text]="modalAlert.text"
	(onAction)="modalAlert.cb($event)"
></ui-alert>

<ui-table
	[chunker]="clashes.chunker" (chunked)="clashes.chunkedData = $event" [filters]="true"
	[headers]="clashes.headers"
	[options]="clashes.tableOptions"
>
	<tr *ngFor="let option of clashes.chunkedData" (click)="clash_select(option)" class="helper-clickable {{clashes.selected.Id==option.Id?'active':''}}">
		<td>{{ option.SORUser.FirstName }}</td>
		<td>{{ option.SORUser.LastName }}</td>
		<td>{{ option.SODClashDefinition.SystemRole1.System.Name }}</td>
		<td [title]="option.SODClashDefinition.SystemRole1.MappedName">{{ option.SODClashDefinition.SystemRole1.Name }}</td>
		<td>{{ option.SODClashDefinition.SystemRole2.System.Name }}</td>
		<td [title]="option.SODClashDefinition.SystemRole2.MappedName">{{ option.SODClashDefinition.SystemRole2.Name }}</td>
		<td>{{ option.Age }} days</td>
		<td class="helper-capitalize">

			<span *ngIf="option.StatusId==='accepted'" class="material-icons color-green green-important " style=" position:absolute;   margin-left: 12px;margin-top: -1px;">
				done
				</span>

			<span *ngIf="option.StatusId==='rejected'" class="material-icons color-red red-important" style="   position:absolute; margin-left: 12px;margin-top: -1px;">
				close
				</span>

			<span *ngIf="option.StatusId==='clashing' || option.StatusId==='expired'" class="color-red red-important">Pending</span>

			<span *ngIf="option.StatusId==='expired'" class="color-red red-important"> (Expired)</span>
		</td>
	</tr>
</ui-table>
<br/>
<div class="card" *ngIf="clashes.selected.Id">
	<div class="card-header">
		<h2>SOD Clash for {{ clashes.selected.SORUser.FirstName }} {{ clashes.selected.SORUser.LastName }}</h2>
		<ui-table [headers]="[

						{label:'System 1'},
						{label:'Standard Role Name 1'},
						{label:'System 2'},
						{label:'Standard Role Name 2'}
						]"
				  [options]="{noToolbar:true,noEmptyText:true}"
				  [chunker]="clash.chunker"
		>
			<tr *ngFor="let option of [clashes.selected]">
				<td>{{ option.SODClashDefinition.SystemRole1.System.Name }}</td>
				<td>{{ option.SODClashDefinition.SystemRole1.MappedName }}</td>
				<td>{{ option.SODClashDefinition.SystemRole2.System.Name }}</td>
				<td>{{ option.SODClashDefinition.SystemRole2.MappedName }}</td>
			</tr>
		</ui-table>
	</div>
	<div class="card-body row">
		<div class="col-lg-6">
			<ul>
				<li *ngFor="let no of clash.notes" style="margin-bottom: 30px">
					<div class="" style="border-bottom:1px solid #ced4da;">

						<small [matTooltip]="no.DateCreated|date:'dd/MM/yyyy HH:mm'">
							{{ no.DateCreated|dateago }} by {{ no.CreatedBy }}
						</small>
					</div>
					<p>
						<span *ngIf="no.Decision=='accept' || no.Decision=='reject'" [class]="(no.Decision=='accept'?'green-important':'red-important')">{{ no.Decision == 'accept' ? 'Approved' : 'Rejected' }}</span>
						&nbsp;
						<span style="white-space: pre-line;">{{ no.Message }}</span>

					</p>

					<div class="alert alert-warning" *ngIf="no.Decision=='accept'">
						valid until {{ no.ValidUntil|date }}
					</div>
					<div *ngIf="hasAttachments(no)">
						<i class="material-icons material" style="position: absolute;color:#0000006b">attachment</i>

						<div style="margin-left: 25px">
							<div *ngFor="let a of attachmentsAsArray(no)" (click)="downloadAttachment(a)" class="btn btn-small" style="

						width: 250px;
    overflow: hidden;
    margin-right: 5px;
    line-height: 12px;
    background: #cccccc61;
    font-size: 11px;
    display: inline-block;
    height: 24px;
    white-space: nowrap;
">

								{{ a.name }}
							</div>
						</div>
					</div>
				</li>
			</ul>
		</div>
		<div class="col-lg-6">
			<div class="form-group" *ngIf="isSuperApprover">
				<select name="decision" class="form-control" [(ngModel)]="clash.newNote.decision">
					<option value="note">Add a Note</option>
					<option value="accept">Accept the clash</option>
				</select>
			</div>

			<div class="form-group mt-1" *ngIf="clash.newNote.decision=='accept'">
				Exception until
				<ui-input-datepicker
					[(ngModel)]="clash.newNote.exceptionValidUntil"
					(ngModelChange)="clash.newNote.exceptionValidUntil=$event"
					[name]="'datevaliduntil'"
					[presentationMode]="false"
				></ui-input-datepicker>
			</div>

			<div class="form-group mt-1">
				<textarea [(ngModel)]="clash.newNote.message" name="newnote" class="form-control"></textarea>
			</div>

			<div class="form-group mt-1">
				<ui-uploader [parent]="self"></ui-uploader>
			</div>

			<div class="form-group mt-1">
				<button class="btn btn-primary" (click)="clash_add_note()">{{ isSuperApprover ? 'Apply' : 'Add Note' }}</button>
			</div>
		</div>
	</div>
</div>
